module.exports = __webpack_public_path__ + "img/vector.5079a07d.svg";